
import { Component, Vue } from 'vue-property-decorator'
import ClueTable from './clue_table/index.vue'
import ReporterTable from './reporter_table/index.vue'
import MediaTable from './media_table/index.vue'

const tabMap = {
    clue: {
        key: 'clue', name: '线索广场报料'
    },
    reporter: {
        key: 'reporter', name: '向记者报料'
    },
    media: {
        key: 'media', name: '向媒体报料'
    }
}

@Component({
    name: 'report-list',
    components: {
        ClueTable,
        ReporterTable,
        MediaTable
    }
})
export default class extends Vue {
    private curTab = tabMap.clue.key
    private tabMap = tabMap
}
